import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MainContent from "@components/content";
import TinyMceEditor from "./editor";

import axios from 'axios';
import { toast } from "sonner";

export default function AdmPost() {
    let { id } = useParams();

    return (
        <MainContent>
            {id == 'new' ?
                <>
                    <div className="lh-100" style={{ marginBottom: 20 }}>
                        <h1 style={{ fontSize: 24, color: "var(--text-color)", fontWeight: 700 }}>Новая публикация</h1>
                        <Create />
                    </div>
                </>
                :
                <>
                    <div className="lh-100" style={{ marginBottom: 20 }}>
                        <h1 style={{ fontSize: 24, color: "var(--text-color)", fontWeight: 700 }}>Редактирование публикации</h1>
                        <Edit />
                    </div>
                </>
            }
        </MainContent>
    )
}

const Create = () => {
    const [content, setContent] = useState("");
  
    const handleSubmit = async (event: any) => {
      event.preventDefault();
      const formData = new FormData(event.target);
      formData.append("content", content);
  
      axios.post(`${import.meta.env.VITE_API_ADM_URL}/blog`, formData, {
      headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + localStorage.getItem('authToken')
      }})
      .then(response => {
          event.target.reset();
          window.location.replace("/admin/blog");
      })
    };
  
    return (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <div style={{ display: 'grid', gap: 10 }}>
                <label style={{ marginTop: 10 }}>Название публикации</label>
                <input name="name" placeholder="Название публикации" required/>
            </div>

            <div style={{ display: 'grid', gap: 10 }}>
                <label style={{ marginTop: 10 }}>Содержание публикации</label>
                <div>
                    <TinyMceEditor initialValue={content} editorChange={setContent} />
                </div>
            </div>
            
            <div style={{ display: 'grid', gap: 10 }}>
                <label style={{ marginTop: 10 }}>Обложка публикации</label>
                <input type="file" name="file" required/>
            </div>
    
            <button type="submit">Опубликовать</button>
        </form>
    );
};
  
  
const Edit = () => {
    const [content, setContent] = useState("");
    const [jsonData, setJson] = useState<any>({});
    let { id } = useParams();

    useEffect(() => {
        axios.get(`${import.meta.env.VITE_API_ADM_URL}/blog/${id}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('authToken')
        }
        })
        .then(response => {
            setJson(response.data);
            setContent(response.data.content);
        })
    }, []);

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        formData.append('content', content);

        axios.post(`${import.meta.env.VITE_API_ADM_URL}/blog/${id}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                'Authorization': 'Bearer ' + localStorage.getItem('authToken')
            }
            })
            .then(response  => {
                toast.success("Публикация обновлена");    
            })
    };
    
    return (
      <>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <div style={{ display: 'grid', gap: 10 }}>
                <label style={{ marginTop: 10 }}>Название публикации</label>
                <input defaultValue={jsonData?.name} name="name" placeholder="Название публикации" required/>
            </div>

            <div style={{ display: 'grid', gap: 10 }}>
                <label style={{ marginTop: 10 }}>Содержание публикации</label>
                <TinyMceEditor initialValue={content} editorChange={setContent} />
            </div>
            
            <div style={{ display: 'grid', gap: 10 }}>
                <label style={{ marginTop: 10 }}>Обложка публикации</label>
                <input type="file" name="file" required/>
            </div>

            <button type="submit">Обновить публикацию</button>
        </form>
      </>
    );
};
